import { Link } from "react-router-dom";

/**
 * Brand — merkezi logo/wordmark slotu.
 *
 * Logo dosyası bağlanacağı zaman:
 *   1. /app/frontend/public/logo.svg (veya .png) altına dosyayı koyun
 *   2. Aşağıdaki LOGO_ASSET_URL sabitini "/logo.svg" olarak güncelleyin
 *   3. Bileşen otomatik olarak wordmark yerine görsel gösterecek
 *
 * variant:
 *   "hero"    — büyük login hero için (48-56px yüksekliği hedefler)
 *   "sidebar" — admin sidebar başlığı
 *   "compact" — portal header, mobil
 *   "footer"  — küçük gri wordmark
 */
const LOGO_ASSET_URL = "/tattoompark-logo.png"; // beyaz logo, Emergent asset bucket'tan indirildi

export default function Brand({ variant = "sidebar", href = "/", withSubtitle = true, subtitle }) {
  const sizes = {
    hero: { wordmark: "text-5xl sm:text-6xl", subtitle: "text-[11px] tracking-[0.45em]", img: "h-14" },
    sidebar: { wordmark: "text-2xl", subtitle: "text-[10px] tracking-[0.28em]", img: "h-8" },
    compact: { wordmark: "text-lg", subtitle: "text-[9px] tracking-widest", img: "h-6" },
    footer: { wordmark: "text-sm", subtitle: "text-[9px] tracking-widest", img: "h-4" },
  }[variant];

  const wordmark = LOGO_ASSET_URL ? (
    <img
      src={LOGO_ASSET_URL}
      alt="Tattoompark"
      data-testid="brand-logo-img"
      className={`${sizes.img} w-auto object-contain`}
    />
  ) : (
    <div
      data-testid="brand-wordmark"
      className={`font-display font-bold leading-none tracking-tight ${sizes.wordmark}`}
    >
      TATTOOM<span className="text-brand-red">PARK</span>
    </div>
  );

  const content = (
    <div className="inline-flex flex-col items-start gap-1.5" data-testid={`brand-slot-${variant}`}>
      {wordmark}
      {withSubtitle && (
        <div className={`${sizes.subtitle} uppercase text-neutral-500`}>
          {subtitle || "Tattoompark Yönetim"}
        </div>
      )}
    </div>
  );

  if (href === false) return content;
  return <Link to={href} className="block group">{content}</Link>;
}
